

const sgurl = 'styleguide';



export const config = { 
    version: process.env.REACT_APP_VERSION,
    wsServer : process.env.REACT_APP_WEB_SERVICES_ROOT,
    imageRoot : process.env.REACT_APP_IMAGE_ROOT,
    rrr : process.env.REACT_APP_GMAP_TILES_STD,
    pageTitleBase: 'UMC Style Guide',
    rootOrg: 224,
    basePath : '',
    error_codes: {
            '404' : 'Not Found'
        }
};


var basepathPos = window.location.pathname.indexOf(sgurl);
if ( basepathPos > -1 ) {
    config.basePath = window.location.pathname.substring(0, basepathPos + sgurl.length  );
}